/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import './AddProductModal.scss';
import { selectHnLPlantCode } from '../../store/modules/product/selectors';

const AddProductModal = ({
  show, toggle, onSubmit, values, fetchPlantCodes,
}) => {
  const showHideClassName = show ? 'edit-user-modal display-block' : 'edit-user-modal display-none';
  const {
    register, handleSubmit, setValue, formState: { errors },
  } = useForm();
  const HnLplantCodeValues = useSelector((state) => selectHnLPlantCode(state));

  useEffect(() => {
    if (values) {
      setValue('plantName', values.plantName);
      setValue('productName', values?.productName);
      setValue('plantCode', values?.plantCode);
      setValue('uom', values?.uom ?? values?.uom);
      setValue('materialCode', values?.materialCode);
      setValue('productCategory', values?.productCategory);
    }
  }, [setValue, values]);

  const submit = ({
    uom,
    plantName,
    plantCode,
    productName,
    materialCode,
    productCategory,
  }) => {
    onSubmit({
      uom,
      plantName,
      productName,
      plantCode,
      materialCode,
      productCategory,
    });
    toggle();
  };

  const handlePlantCodeChange = (e) => {
    const selectedPlantCode = e.target.value;
    fetchPlantCodes(selectedPlantCode);
  };

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        <div className="row">
          <div className="col-12 d-flex end">
            <button type="button" className="modal-main__button" onClick={toggle}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="col-12">
            <div className="form">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Plant Name</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="plantName"
                            name="plantName"
                            placeholder="Plant Name"
                            {...register('plantName', { required: { value: true, message: 'Plant Name is required' } })}
                          />
                          {errors.plantName && <div className="form__error">{errors.plantName.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Plant Code</span>
                        </div>
                        <div className="col-12">
                          <select
                            className="form__field"
                            id="plantCode"
                            name="plantCode"
                            {...register('plantCode', { required: { value: true, message: 'Plant Code is required' } })}
                            onChange={handlePlantCodeChange}
                          >
                            <option hidden value="">Choose here</option>
                            {Array.isArray(HnLplantCodeValues)
                            && HnLplantCodeValues?.map((item, index) => (
                              <option key={index.toString()} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                          {errors.plantCode && <div className="form__error">{errors.plantCode.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Material Code</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="materialCode"
                            name="materialCode"
                            placeholder="Material Code"
                            {...register('materialCode', { required: { value: true, message: 'Material Code is required' } })}
                          />
                          {errors.materialCode && <div className="form__error">{errors.materialCode.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Product Name</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="productName"
                            name="productName"
                            placeholder="Product Name"
                            {...register('productName', { required: { value: true, message: 'Product Name is required' } })}
                          />
                          {errors.productName && <div className="form__error">{errors.productName.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Unit of Measurement</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="uom"
                            name="uom"
                            placeholder="Unit of Measurement"
                            {...register('uom', { required: { value: true, message: 'Unit of Measurement is required' } })}
                          />
                          {errors.uom && <div className="form__error">{errors.uom.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Product Category</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="productCategory"
                            name="productCategory"
                            placeholder="Product Category"
                            {...register('productCategory', { required: { value: true, message: 'Product Category is required' } })}
                          />
                          {errors.productCategory && <div className="form__error">{errors.productCategory.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form__item">
                    <div className="row">
                      <div className="col-12 d-flex-col middle">
                        <button type="submit" className="form__button" onClick={handleSubmit(submit)}>Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddProductModal;
